import { defineStore } from 'pinia'
import * as api from '@/network/api/menu.api.js'
import { structureMenuParser } from '@/assets/scripts/parsers/menu'

export const useMenuStore = defineStore('menuStore', {
    state: () => ({
        menu: null,
        submenu: null
    }),
    getters: {
        getMenu: (state) => state.menu,
        getSubMenu: (state) => state.submenu
    },
    actions: {
        async menuFetch(payload) {
            if (this.menu && this.menu.length) return
            const res = await api.menu(payload)
            if (res) {
                this.menu = structureMenuParser(res.data.data)
            }
            return res
        },
        async submenuFetch(payload) {
            const res = await api.submenu()
            if (res) {
                this.submenu = res.data.data.subMenuItemViewList
            }
            return res
        },
        async updateMenu(payload) {
            this.menu = structureMenuParser(payload)
        }
    }
})
